export interface AuthProvider {
    id: string,
    name: string,
    route: string,
    popupWidth: number,
    popupHeight: number,
    backgroundColor: string,
    textColor: string,
};

export const providers: AuthProvider[] = [
    {
        id: 'google',
        name: 'Google',
        route: (window as any).route('auth.social', 'google'),
        popupHeight: 650,
        popupWidth: 375,
        backgroundColor: '#fff',
        textColor: '#666D7B'
    },
    {
        id: 'facebook',
        name: 'Facebook',
        route: (window as any).route('auth.social', 'facebook'),
        popupHeight: 700,
        popupWidth: 700,
        backgroundColor: '#4267b2',
        textColor: '#fff'
    }
]

export default {
    providers
}
